import { Vectorizer } from './vectorizer';
export const isVector = Vectorizer.isVector;
export const createVector = Vectorizer.createVector;
export const createVectors = Vectorizer.createVectors;
export const toHTMLElement = Vectorizer.toHTMLElement;
export const toHTMLElements = Vectorizer.toHTMLElements;
//# sourceMappingURL=vector.js.map